export default "__VITE_ASSET__S10s6cAX__"